/**
 * quicklinksactions.js
 * Created by calhosh on 8/27/2020.
 */
import * as types from '../actiontypes';
import env from '../../util/env';
import { promiseAreas, serviceURL } from '../../util/uiconstants';

export const getQuickLinks = (engagementId) => {
	const url = env.getBaseURL(serviceURL, Number(engagementId)) + 'QuickLinks';

	return {
		type: types.GET_QUICKLINKS_BY_ENGAGEMENTID,
		meta: {
			api: {
				url,
				method: 'GET',
				trackWithArea: promiseAreas.QUICK_LINK_AREA
			}
		}
	};
};